import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-pbisschool-or-district",
	templateUrl: "./pbisschool-or-district.component.html",
	styleUrls: ["./pbisschool-or-district.component.css"],
})
export class PBISSchoolOrDistrictComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.SchoolName = this.dialogConfig.data.SchoolName;
	}

	SchoolName: any = "";

	onDistrictAdd() {
		this.onClose(0);
	}

	onSchoolAdd() {
		this.onClose(1);
	}

	//-1 cancel, 0 district, 1 school
	onClose(val) {
		this.ref.close(val);
	}
}
